module.exports = __webpack_public_path__ + "img/electricMotorcycle-green.1187a639.svg";